export default "__VITE_ASSET__06d3ef95__"